import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the user profile table view.
 */
export default class tableUsuarioPerfilView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // Preloader ID
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // DataTable ID
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                {
                                    id: 'User', // Column ID for User
                                    header: _('Usuario'), // Column header with localization
                                    width: 170, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Profile', // Column ID for Profile
                                    header: _('Perfil'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            url: devConfig.geturlApi() + 'es/UserManagement/GetUsuarioPerfil', // Data source URL
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        var url = grid.data.url; // Store the data URL
        var filter = ''; // Initialize filter string

        // Event listener for filtering data
        this.on(this.app, 'usuarioPerfil:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            // Loop through filter data entries
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Convert start date to Date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Convert end date to Date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Load data based on selected player
        });
    }
}

// FILE DOCUMENTED
